import { BaseRecord } from 'app/context/data/types';
import { BaseHeader, BlankLayout, Status } from 'app/modules/ui';
import {
  PRESETS_INSPECTION_RESULT,
  PRESETS_INSPECTION_STATUS
} from '../../constants';

export const HeaderDescriptionDefs: Array<{
  label: string;
  dataIndex: string;
  render?: (
    value: any,
    inspection?: BaseRecord,
    meta?: {
      progress;
    }
  ) => any;
}> = [
  {
    label: 'Job ID',
    dataIndex: 'jobNoList',
    render: (value: { jobNo: string }) => {
      return value?.jobNo || 'N/A';
    }
  },
  {
    label: 'Overall Report Result',
    dataIndex: 'overallReportResult',
    render: (value, record, meta) => {
      const { progress } = meta || {};
      if (progress?.overallResult) {
        const [status, color] = PRESETS_INSPECTION_RESULT.get(
          progress.overallResult
        );
        return <Status type="text" value={status} color={color as string} />;
      }
    }
  },
  {
    label: 'Status',
    dataIndex: 'status',
    render: (value) => {
      const status = PRESETS_INSPECTION_STATUS.get(value);
      if (status) {
        const [label, color] = status;
        return (
          <Status
            borderless
            type="tag"
            value={label}
            color={color as string}
          ></Status>
        );
      }
      return value || 'N/A';
    }
  }
];
